import { render, staticRenderFns } from "./edit_daily_menu.vue?vue&type=template&id=2f9e96e5&scoped=true"
import script from "./edit_daily_menu.vue?vue&type=script&lang=js"
export * from "./edit_daily_menu.vue?vue&type=script&lang=js"
import style0 from "./edit_daily_menu.vue?vue&type=style&index=0&id=2f9e96e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9e96e5",
  null
  
)

export default component.exports